import { cva } from "../../../node_modules/.pnpm/class-variance-authority@0.7.1/node_modules/class-variance-authority/dist/index.js";
const calendarCustomButtonVariants = cva(
  "block w-full",
  {
    variants: {
      target: {
        default: "text--(--gray-text-2-alpha)",
        target: "bg-(--primary-1) hover:bg-(--primary-1) text-(--pure-white)",
        outsideView: "text-(--gray-primary-2-alpha)"
      }
    },
    defaultVariants: {
      target: "default"
    }
  }
);
export {
  calendarCustomButtonVariants
};
//# sourceMappingURL=variants.js.map
